module.exports = __webpack_public_path__ + "img/blog-3-pic-1.fabf0390.jpg";